import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import moment from 'moment';

const AdminPayments = () => {
  const navigate = useNavigate();
  const [paymentData, setpaymentData] = useState([]);

  const fetchpaymentData = async () => {
    try {
      const response = await getApi(`api/payments/totalPayment`);
      console.log("responsepayment================>>>",response)
      setpaymentData(response?.data?.paymentsData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchpaymentData();
  }, []);

  const columns = [
    {
      field: 'hotelName',
      headerName: 'Hotel Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box
            sx={{ cursor: 'pointer', color: 'blue', fontWeight: 'bold' }}
            onClick={() => {
              navigate(`/dashboard/hotel/view/${params.row.hotelId}`);
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'packageName',
      headerName: 'Package Name',
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'amount',
      headerName: 'Package Amount',
      flex: 1.5,
      align: 'center',
      headerAlign: 'right',
      renderCell: (params) => {
        return <Box>Rs {params.value}</Box>;
      },
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'duration',
      headerName: 'Duration',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return <Box>{params.value} Day(s)</Box>;
      },
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 2,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      },
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      flex: 2,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        let color;
        switch (params.value) {
          case 'active':
            color = 'success';
            break;
          case 'expired':
            color = 'error';
            break;
          case 'expiresSoon':
            color = 'warning';
            break;
          default:
            color = 'inherit';
            break;
        }
        return (
          <Button variant="contained" color={color}>
            {params.value}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Payments-Management</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Payments ( {paymentData?.length} )
              </Typography>
              <DataGrid
                rows={paymentData}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row?._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default AdminPayments;
